import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandTermsPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "BrandTermsPage" */ './Container'),
  'page'
);
